import { 
  collection, doc, getDoc, getDocs, addDoc, setDoc, 
  updateDoc, query, orderBy, serverTimestamp,
  onSnapshot, where, deleteDoc, collectionGroup
} from 'firebase/firestore';
import ChatRoom from './chat_room';
import ChatAddRoom from './chat_add_room';
import ChatUserSettings from './chat_user_settings';
import { get_rooms, mark_message_read } from './chat_utils';

export default class ChatList {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.user = opts.user;
    this.user_email = opts.user_email;
    this.is_admin = opts.is_admin;
    this.setup();
  }

  setup() {
    this.$chat_list = $(document.createElement('div'));
    this.$chat_list.addClass('chat-list');
    this.setup_header();
    this.setup_search();
    this.fetch_and_setup_rooms();
    this.setup_socketio();
  }

  setup_header() {
    const chat_list_header_html = `
			<div class='chat-list-header'>
				<h3>${__('Chats')}</h3>
        <div class='chat-list-icons'>
          <div class='add-room' 
            title='Create Private Room'>
            ${frappe.utils.icon('users', 'md')}
          </div>
          <div class='user-settings' 
          title='Settings'>
          ${frappe.utils.icon('setting-gear', 'md')}
          </div>
        </div>
			</div>
		`;
    this.$chat_list.append(chat_list_header_html);
  }

  setup_search() {
    const chat_list_search_html = `
		<div class='chat-search'>
			<div class='input-group'>
				<input class='form-control chat-search-box'
				type='search' 
				placeholder='${__('Search conversation')}'
				>	
				<span class='search-icon'>
					${frappe.utils.icon('search', 'sm')}
				</span>
			</div>
		</div>
		`;
    this.$chat_list.append(chat_list_search_html);
  }

  async fetch_and_setup_rooms() {
    try {
      const res = await get_rooms(this.user_email);
      this.rooms = res;
      this.setup_rooms();
      this.render_messages();
    } catch (error) {
      frappe.msgprint({
        title: __('Error'),
        message: __('Something went wrong. Please refresh and try again.'),
      });
    }
  }

  setup_rooms() {
    this.$chat_rooms_container = $(document.createElement('div'));
    this.$chat_rooms_container.addClass('chat-rooms-container');
    this.chat_rooms = [];

    this.rooms.forEach((element) => {
      let profile = {
        user: this.user,
        user_email: this.user_email,
        last_message: element.last_message,
        last_date: element.modified,
        is_admin: this.is_admin,
        room: element.name,
        is_read: element.is_read,
        room_name: element.room_name,
        room_type: element.type,
        opposite_person_email: element.opposite_person_email,
      };

      this.chat_rooms.push([
        profile.room,
        new ChatRoom({
          $wrapper: this.$wrapper,
          $chat_rooms_container: this.$chat_rooms_container,
          chat_list: this,
          element: profile,
        }),
      ]);
    });
    this.$chat_list.append(this.$chat_rooms_container);
  }

  fitler_rooms(query) {
    for (const room of this.chat_rooms) {
      const txt = room[1].profile.room_name.toLowerCase();
      if (txt.includes(query)) {
        room[1].$chat_room.show();
      } else {
        room[1].$chat_room.hide();
      }
    }
  }

  create_new_room(profile) {
    // Check if room already exists
    const existingRoomIndex = this.chat_rooms.findIndex(room => room[0] === profile.room);
    
    if (existingRoomIndex !== -1) {
      // If room exists, move it to top
      const existingRoom = this.chat_rooms[existingRoomIndex];
      this.chat_rooms.splice(existingRoomIndex, 1);
      this.chat_rooms.unshift(existingRoom);
      existingRoom[1].render('prepend');
      return;
    }

    console.log(`Creating new room in UI: ${profile.room_name}`);

    // Create new room object
    const newRoomObj = new ChatRoom({
      $wrapper: this.$wrapper,
      $chat_rooms_container: this.$chat_rooms_container,
      chat_list: this,
      element: profile,
    });
    
    // Add to rooms array
    const newRoom = [profile.room, newRoomObj];
    this.chat_rooms.unshift(newRoom);
    
    // Force render it to the DOM
    newRoomObj.render('prepend');
    
    // Make sure it's visible and handle any CSS
    newRoomObj.$chat_room.css('display', 'flex');
    
    // If we're in another view, return to chat list view to show the new room
    if (!$('.chat-rooms-container').is(':visible')) {
      // If there's a current chat space, hide it
      if ($('.chat-space').length) {
        $('.chat-space').remove();
      }
      // Show the chat list
      this.$wrapper.html(this.$chat_list);
      this.setup_events();
    }
    
    // Show notification for new room
    if (profile.room_type === 'Direct') {
      frappe.show_alert({
        message: __(`New chat from ${profile.room_name}`),
        indicator: 'green'
      });
      
      // Play notification sound if enabled
      if (frappe.Chat.settings.user.enable_notifications === 1) {
        frappe.utils.play_sound('chat-notification');
      }
    }
  }

  setup_events() {
    const me = this;
    $('.chat-search-box').on('input', function (e) {
      me.fitler_rooms($(this).val().toLowerCase());
    });

    $('.add-room').on('click', function (e) {
      if (typeof me.chat_add_room_modal === 'undefined') {
        me.chat_add_room_modal = new ChatAddRoom({
          user: me.user,
          user_email: me.user_email,
          chat_list: me
        });
      }
      me.chat_add_room_modal.show();
    });

    $('.user-settings').on('click', function (e) {
      if (typeof me.chat_user_settings === 'undefined') {
        me.chat_user_settings = new ChatUserSettings();
      }
      me.chat_user_settings.show();
    });
  }

  render_messages() {
    this.$chat_rooms_container.empty();
    for (const element of this.chat_rooms) {
      element[1].render('append');
    }
  }

  render() {
    this.$wrapper.html(this.$chat_list);
    this.setup_events();
  }

  move_room_to_top(chat_room_item) {
    this.chat_rooms = [
      chat_room_item,
      ...this.chat_rooms.filter((item) => item !== chat_room_item),
    ];
  }

  setup_socketio() {
    const me = this;
    
    // Initialize chat_rooms if not already initialized
    if (!me.chat_rooms) {
      me.chat_rooms = [];
    }

    // Set up listeners for room changes in Firestore
    const roomsRef = collection(frappe.firebase.db, 'rooms');
    
    // Create a query for rooms where the current user is a member
    const q = query(roomsRef, where('members', 'array-contains', me.user_email));
    
    // Listen for room changes (new messages, etc.)
    this.roomListener = onSnapshot(q, (snapshot) => {
      console.log(`Room changes detected: ${snapshot.docChanges().length} changes`);
      
      snapshot.docChanges().forEach((change) => {
        const roomData = change.doc.data();
        const roomId = change.doc.id;
        
        console.log(`Room change: ${change.type} for room ${roomId}`);
        
        if (change.type === 'added') {
          // A new room was created with this user as a member
          // Check if room already exists in our list
          const existingRoom = me.chat_rooms.find(room => room[0] === roomId);
          if (!existingRoom) {
            console.log("New room detected:", roomData.room_name, "members:", roomData.members); 
            const millis = roomData.created_at.seconds * 1000 + roomData.created_at.nanoseconds / 1000000;
            const date = new Date(millis);      
            const lastDate = date.toISOString();
            // Create a profile for the new room
            const profile = {
              room: roomId,
              room_name: roomData.room_name || 'Unnamed Room',
              room_type: roomData.type || 'Direct',
              last_message: roomData.last_message?.content || '',
              last_date: lastDate,
              is_admin: me.is_admin,
              user: me.user,
              user_email: me.user_email,
              is_read: true
            };
            
            // Add opposite person email for direct chats
            if (roomData.type === 'Direct' && roomData.members) {
              profile.opposite_person_email = roomData.members.find(m => m !== me.user_email);
            }
            
            // Create the new room in UI
            me.create_new_room(profile);
            
            // Play notification sound if enabled
            if (frappe.Chat.settings.user.enable_notifications === 1) {
              frappe.utils.play_sound('chat-notification');
            }
            
            // Show notification for the new room
            frappe.show_alert({
              message: __(`New chat room: ${profile.room_name}`),
              indicator: 'green'
            });
          }
        }
        else if (change.type === 'modified') {
          // Check if this room is in our list
          const roomIndex = me.chat_rooms.findIndex(room => room[0] === roomId);
          if (roomIndex !== -1) {
            const roomObj = me.chat_rooms[roomIndex][1];
            
            // Update last message if it changed
            if (roomData.last_message && roomData.last_message.content) {
              roomObj.update_last_message(roomData.last_message.content);
            }
          }
        }
      });
    }, (error) => {
      console.error("Error in room listener:", error);
    });
    
    // Listen for room deletions
    const deletionsRef = collection(frappe.firebase.db, 'room_deletions');
    this.deletionListener = onSnapshot(deletionsRef, (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const deletionData = change.doc.data();
          const roomId = change.doc.id;
          
          // Only handle if we're not the one who deleted it
          if (deletionData.deleted_by !== frappe.session.user) {
            // Find and remove the room from UI
            const roomIndex = me.chat_rooms.findIndex(room => room[0] === roomId);
            if (roomIndex !== -1) {
              const room = me.chat_rooms[roomIndex];
              
              // Remove from DOM
              room[1].$chat_room.remove();
              
              // Remove from our array
              me.chat_rooms.splice(roomIndex, 1);
              
              frappe.show_alert({
                message: __(`${room[1].profile.room_name} was deleted`),
                indicator: 'red',
              });
            }
          }
        }
      });
    });
  }

  destroy() {
    // Clean up Firestore listeners
    if (this.roomListener) {
      this.roomListener();
    }
    if (this.deletionListener) {
      this.deletionListener();
    }
  }
}